<ng-container [formGroup]="group">
  @if (group.get(config.name); as field) {
    <div class="custom-field radio-list" [ngClass]="{ 'custom-field--invalid': showError(field) }" [class.has--label]="!!config.label">
      <span class="label" (click)="collapsed = !collapsed">
        <span class="d-inline-block me-2">
          {{ config.label }}
          @if (isRequired(field)) {
            <span class="mat-form-field-required-marker">*</span>
          }
        </span>
        <app-icon class="icon-xxxs collapsable-field-toggle" [class.is--active]="collapsed" anchor="icon-chevron-down-xxs"></app-icon>
      </span>
      @if (config.subLabel) {
        <div class="mat-form-field-subLabel" [innerHTML]="config.subLabel"></div>
      }
      <ul
        class="custom-field__field collapsable-field"
        [class.is--collapsed]="collapsed"
        #collapsable
        [style.--collapsable-height]="collapsableHeight"
      >
        @for (option of config.selectOptions; track option.id) {
          <li class="me-2 my-2">
            <button type="button" class="radio" (click)="toggleOption(option.id)">
              <input [formControlName]="config.name" type="radio" [value]="option.id" hidden="hidden" />
              <span class="radio__bullet me-2" [class.is--selected]="group.get(config.name)?.value === option.id"></span>
              <span class="radio__label">{{ option.title }}</span>
            </button>
          </li>
        }
      </ul>
      <div class="custom-field__error-wrapper">
        @if (showError(field)) {
          <div>
            {{ error(field) }}
          </div>
        }
      </div>
    </div>
  }
</ng-container>
